import  { tns } from "tiny-slider/src/tiny-slider";
const praxisSlider = document.getElementsByClassName('praxis-slider');

document.querySelectorAll('.slider').forEach(slider => {
  tns({
    container: slider.querySelector('.slider-elements'),
    items: 1,
    nav:false,
    prevButton: slider.querySelector('.slider-prev'),
    nextButton: slider.querySelector('.slider-next'),
    autoHeight: true
  });
});

if (praxisSlider.length){

    const nextButton = document.querySelector('.praxis-slider-next');
    const prevButton = document.querySelector('.praxis-slider-prev');

    const slider = tns({
        container: '.praxis-slider',
        items: 1,
        nav:false,
        prevButton: prevButton,
        nextButton: nextButton,
        autoHeight: true
    })
}

const teamSlider = document.getElementsByClassName('team-slider');

if (teamSlider.length){

    const nextButton = document.querySelector('.team-slider-next');
    const prevButton = document.querySelector('.team-slider-prev');

    const slider = tns({
        container: '.team-slider',
        items: 3,
        nav:false,
        responsive:{
            0:{
                items:1
            },
            640: {
                items: 2
            },
            1024: {
                items: 3
            }
        },
        prevButton: prevButton,
        nextButton: nextButton
    })
}
